import { styled } from '@linaria/react';
import { fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const CardWrapper = styled.div<{ $unavailable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-400']};
  padding: ${space['space-400']};
  background: ${({ $unavailable }) => ($unavailable ? semantic.bg.disabled : semantic.bg.canvas)};
  border: 1px solid ${semantic.border.subtle};
  border-radius: ${size.radius['radius-md']};
  opacity: ${({ $unavailable }) => ($unavailable ? 0.7 : 1)};

  @media (max-width: ${layout.desktopBreakpoint}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${space['space-300']};
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  min-width: 0;
  flex: 1;
`;

export const Thumbnail = styled.div`
  width: 48px;
  height: 48px;
  border-radius: ${size.radius['radius-sm']};
  overflow: hidden;
  flex-shrink: 0;
  background: ${semantic.bg.surfaceSubtle};
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${semantic.bg.surfaceSubtle};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  min-width: 0;
`;

export const Name = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const UnavailableTextWrapper = styled.div`
  background: ${semantic.bg.canvas};
  padding: ${space['space-200']} ${space['space-300']};
  border-radius: ${size.radius['radius-lg']};
  display: grid;
  grid-template-columns: auto auto;
  gap: ${space['space-200']};
`;

export const Label = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-400']};
  flex-shrink: 0;
`;

export const SelectButton = styled.button`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.semiBold};
  background: ${semantic.text.primary};
  color: ${semantic.text.inverse};
  border: none;
  border-radius: 20px;
  padding: ${space['space-200']} ${space['space-500']};
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }
`;

export const UnavailableText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const PriceWrapper = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;
